/** @deprecated */
export var dash = "<svg id=\"Gruppe_18648\" xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 20 20\"><path id=\"Rechteck_5983\" transform=\"translate(2 8)\" d=\"M0 0h16v4H0z\"/></svg>";